import {
  VTextField,
  VAutocomplete,
  VTextarea,
} from 'vuetify/components';

import DynamicJsonField from '@/components/form/DynamicJsonField.vue';
import DatePickerInput from '@/components/form/DatePickerInput.vue';
import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [
  {
    value: 'sale',
    label: 'Venta',
    component: VAutocomplete,
    searchValue: 'id',
    required: true,
    col: 12,
    fetchOptions: 'searchSales',
    itemText: (item: any) => `${item?.id || ''} ${item?.attributes?.campaign || ''}`.trim(),
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      sale_id: value?.id ?? value,
    })
  },
  {
    value: 'concept',
    label: 'Concepto',
    component: VAutocomplete,
    searchValue: 'name',
    fetchOptions: 'expenseTypesFromStore',
    itemText: 'name',
    itemValue: 'id',
    fetchParams: () => ({
      'filter[name]': 'Conceptos de Gato'
    }),
    required: true,
    col: 6,
  },
  {
    value: 'amount',
    label: 'Monto',
    component: VTextField,
    type: 'number',
    prefix: '$',
    required: true,
    col: 6,
  },
  {
    value: 'payment_date',
    label: 'Fecha de pago',
    component: DatePickerInput,
    required: true,
    col: 6,
  },
  {
    value: 'user',
    label: 'Involucrado',
    component: VAutocomplete,
    searchValue: 'name',
    fetchOptions: 'searchUsers',
    itemText: (item: any) => [item?.name, item?.last_name].filter(Boolean).join(' ') || '',
    itemValue: (item: any) => item,
    fetchParams: () => ({
      'filter[is_active]': 1
    }),
    transform: (value: any) => ({
      user_id: value?.id ?? value
    }),
    required: true,
    col: 6,
  },
  {
    value: 'note',
    label: 'Nota',
    component: VTextarea,
    required: false,
    col: 12,
  },
    /*transform: (items: any[]) =>
      (items || []).map(item => ({
        concept_id: typeof item.concept === 'object' ? item.concept?.id : item.concept,
        amount: item.amount,
        paid_at: item.paid_at,
        user_id: typeof item.user === 'object' ? item.user?.id : item.user,
        note: item.note,
      }))*/
];

export const EDIT_FORM: FormField[] = CREATE_FORM;

export const HEADERS = [
  { title: 'ID', value: 'id', format: 'text', sortable: true },
  { title: 'Venta', value: 'sale.id', format: 'text', sortable: true },
  { title: 'Concepto', value: 'concept.name', format: 'text', sortable: false },
  { title: 'Monto', value: 'amount', format: 'currency', sortable: true,  },
  { title: 'Fecha de pago', value: 'payment_date', format: 'text', sortable: true },
  { title: 'Involucrado', value: 'user.name', format: 'text', sortable: false },
  { title: 'Nota', value: 'note', format: 'text', sortable: false },
];

export const DEFAULT_HEADER_ORDER = ['id', 'sale.id', 'amount', 'payment_date', 'user.name'];

export const ROW_ACTIONS = [
  { label: 'Editar', onClick: '__edit', permission:'expenses.update' },
  { label: 'Eliminar', onClick: '__delete', permission:'expenses.delete' },
];

export const FILTERS = [
  { value: 'id', label: 'ID', component: VTextField },
  { value: 'sale_id', label: 'Venta', component: VTextField },
];

export const DETAIL = {
  expand_table: false,
  eye_detail: false,
  key: 'all',
};
